type MaturityDefinitionEntry = {
  label?: string;
  name?: string;
  order?: number;
};

export function getMaturityDefinitionLabelForValue(
  maturityValue: number,
  maturityConfiguration: MaturityDefinitionEntry[] = []
) {
  if (!Number.isFinite(maturityValue) || !maturityConfiguration.length) {
    return undefined;
  }

  const orderedMaturityEntries = maturityConfiguration
    .slice()
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  const roundedIndex = Math.round(maturityValue);
  const maturityIndex = Math.min(
    Math.max(roundedIndex, 0),
    orderedMaturityEntries.length - 1
  );
  const maturityEntry = orderedMaturityEntries[maturityIndex];

  return maturityEntry?.name || maturityEntry?.label;
}
